import { template as template_78ba782306af42359b6843c302c568e9 } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import OnInsert from 'client-portal/modifiers/on-insert';
import RequestClinicianSearchFacetFilterContent from './facet-filter-content';
import RequestClinicianSearchMobileFiltersTopBar from './mobile-filters-top-bar';
import styles from './mobile-filters-overlay.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
const MODAL_DESTINATION_ID = 'modal-destination';
export default class RequestClinicianSearchMobileFiltersOverlay extends Component {
    @service
    clinicianSearch;
    @service
    intl;
    @service
    router;
    styles = styles;
    @tracked
    destinationElement;
    get overlayClass() {
        let classes = [
            styles.component
        ];
        if (this.router.currentRouteName?.startsWith('widget.')) {
            classes.push('widget-mode');
        }
        return classes.join(' ');
    }
    get filterRows() {
        return this.clinicianSearch.facetNames.names.map((key)=>{
            let details = this.clinicianSearch.facetNames.pillDetails(key);
            return {
                key,
                label: details.baseLabel,
                activeText: details.activeText
            };
        });
    }
    get activeDetailLabel() {
        let key = this.clinicianSearch.mobile.activeDetailKey;
        if (!key) {
            return '';
        }
        return this.clinicianSearch.facetNames.baseLabel(key);
    }
    get applyButtonLabel() {
        let count = this.args.meta?.page?.total ?? 0;
        return this.intl.t('booking.clinicianSearch.mobileFilters.saveSeeTherapists', {
            count
        });
    }
    registerDestination = ()=>{
        this.destinationElement = document.getElementById(MODAL_DESTINATION_ID);
    };
    willDestroy() {
        super.willDestroy(...arguments);
        if (this.clinicianSearch.mobile.isFiltersOverlayOpen && !this.router.currentRouteName?.endsWith('.clinician-search')) {
            this.clinicianSearch.mobile.closeFiltersOverlay();
        }
    }
    static{
        template_78ba782306af42359b6843c302c568e9(`
    <div class="mobile-filters-portal-source" {{OnInsert this.registerDestination}}></div>

    {{#if this.destinationElement}}
      {{#if this.clinicianSearch.mobile.isFiltersOverlayOpen}}
        {{#in-element this.destinationElement}}
          <div
            id="clinician-search-mobile-filters"
            class={{this.overlayClass}}
            role="dialog"
            aria-modal="true"
            aria-labelledby="clinician-search-mobile-filters-title"
            data-test-clinician-search-mobile-filters-overlay
          >
            <div class="mobile-filters-stack">
              <div class="mobile-filters-main">
                <RequestClinicianSearchMobileFiltersTopBar
                  @onBack={{this.clinicianSearch.mobile.closeFiltersOverlay}}
                  @onClear={{this.clinicianSearch.mobile.clearFilters}}
                />

                <div id="clinician-search-mobile-filters-title" class="mobile-filters-heading-row">
                  {{t "booking.clinicianSearch.filterOverlayHeading"}}
                </div>

                <div class="mobile-filters-list">
                  {{#each this.filterRows as |row|}}
                    <button
                      type="button"
                      class="mobile-filters-row-button"
                      data-test-clinician-search-mobile-filter-row={{row.key}}
                      {{on "click" (fn this.clinicianSearch.mobile.openFilterDetail row.key)}}
                    >
                      <span class="mobile-filters-row-label">{{row.label}}</span>
                      {{#if row.activeText}}
                        <span class="mobile-filters-row-active-text">{{row.activeText}}</span>
                      {{/if}}
                      <span class="mobile-filters-row-chevron" aria-hidden="true">
                        {{svgJar "chevron-right"}}
                      </span>
                    </button>
                  {{/each}}
                </div>

                <div class="mobile-filters-apply-wrap">
                  <button
                    type="button"
                    class="button primary mobile-filters-apply-button"
                    data-test-clinician-search-mobile-filters-apply
                    {{on "click" this.clinicianSearch.mobile.applyAndCloseFiltersOverlay}}
                  >
                    {{this.applyButtonLabel}}
                  </button>
                </div>
              </div>

              <div
                class="mobile-filters-detail
                  {{if this.clinicianSearch.mobile.activeDetailKey 'is-open'}}"
                aria-labelledby="clinician-search-mobile-filter-detail-title"
                data-test-clinician-search-mobile-filter-detail
              >
                <span
                  id="clinician-search-mobile-filter-detail-title"
                  class="visually-hidden"
                >{{this.activeDetailLabel}}</span>
                <RequestClinicianSearchMobileFiltersTopBar
                  @variant="detail"
                  @onBack={{this.clinicianSearch.mobile.backFromDetail}}
                  @onClear={{this.clinicianSearch.mobile.clearFilters}}
                />

                <div class="mobile-filters-detail-body">
                  {{#if this.clinicianSearch.mobile.activeDetailKey}}
                    <RequestClinicianSearchFacetFilterContent
                      @facetName={{this.clinicianSearch.mobile.activeDetailKey}}
                    />
                  {{/if}}
                </div>
              </div>
            </div>
          </div>
        {{/in-element}}
      {{/if}}
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
